const AUTHOR = [
  {
    uuid: `kirstie-anderson`,
    surname: `Anderson`,
    forename: `Kirstie`,
    role: `Sleep Doctor`,
    isLead: false,
    honorific: `Dr`,
    avatarImage: { url: `/images/team-kirstie.svg` },
  },
  {
    uuid: `white-et-al`,
    surname: ``,
    forename: `White et al., 2001`,
    isLead: false,
    avatarImage: { url: `/images/m-isc-environmental-therapeutics.svg` },
  },
  {
    uuid: `joe-mcdonald`,
    surname: `McDonald`,
    forename: `Joe`,
    honorific: `Prof`,
    role: `Medical Director`,
    isLead: false,
    avatarImage: { url: `/images/team-joe.svg` },
  },
  {
    uuid: `raminder-mulla`,
    surname: `Mulla`,
    forename: `Raminder`,
    honorific: `Dr`,
    role: `Researcher`,
    isLead: false,
    avatarImage: { url: `/images/team-raminder.svg` },
  },
  {
    uuid: `neil-stanley`,
    surname: `Stanley`,
    forename: `Neil`,
    honorific: `Dr`,
    role: `Director of Sleep Science`,
    isLead: true,
    bio: `Neil has been involved in sleep research for 39 years. He started his career at the Neurosciences Division of the R.A.F. and later became Director of Sleep Research at the University of Surrey. He has published 38 peer-review papers.`,
    avatarImage: { url: `/images/team-neil-s.svg` },
  },
  {
    uuid: `nicola-sunter`,
    surname: `Sunter`,
    forename: `Nicola`,
    honorific: `Dr`,
    role: `Researcher`,
    isLead: false,
    avatarImage: { url: `/images/team-monica.svg` },
  },
]

export default AUTHOR
